import { useState } from "react"
import styled from "styled-components"

import AnimateInFlex, { ANIMATION_BY_KEY } from "#blocks/AnimateInFlex"
import Flex from "#blocks/Flex"
import LinkButton from "#blocks/LinkButton"
import TextOverrun from "#blocks/TextOverrun"
import { Uuid } from "#customTypes/globalTypes"
import AddClassFormModal from "#forms/AddClass/AddClassFormModal"

const SFlex = styled(AnimateInFlex)<{
  border?: boolean
}>`
  border-radius: 6px;
  padding: 4px 16px;
  min-width: 0;
  height: fit-content;
  ${({ border }) => border && "border: 1px solid #ccc;"}
`

const ClickableClassName = ({
  classId,
  label,
  border = false,
  color,
}: {
  classId: Uuid
  label: string
  border?: boolean
  color?: string
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [isHovered, setIsHovered] = useState(false)

  let Content = (
    <LinkButton
      onClick={() => setIsOpen(true)}
      style={{
        minWidth: 0,
        color,
        textDecoration: isHovered ? "underline" : "none",
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <TextOverrun text={label} />
    </LinkButton>
  )

  if (border) {
    Content = (
      <SFlex border={border} animation={ANIMATION_BY_KEY.leftSm}>
        {Content}
      </SFlex>
    )
  } else {
    Content = <Flex>{Content}</Flex>
  }

  return (
    <>
      {Content}
      {isOpen && (
        <AddClassFormModal onClose={() => setIsOpen(false)} classId={classId} />
      )}
    </>
  )
}

export default ClickableClassName
